module.exports = __webpack_public_path__ + "img/20.6cb2da0c.jpg";